import axios from "axios";
import VueCookie from "vue-cookie"
var qs = require('qs');

// const client_id = "6hr6iiqnsv5r748dhokno48o8d"
const aws_domain = "appstats.auth.us-east-1.amazoncognito.com"

let API_aws_demo = axios.create({
    baseURL: `https://${aws_domain}`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
})

API_aws_demo.interceptors.response.use(null, function(error) {
    const response = error.response;

    if (response.status === 400 && response.data.error == "invalid_grant") {
        clearTokens()
        return Promise.resolve(getNewTokensDemo());
    } else {
        return Promise.reject(error)
    }
})

let clearTokens = function() {
    VueCookie.delete('id_token_demo');
}

let storeToken = function(token, tokenName, expires) {
    VueCookie.set(tokenName, token, {
        expires: expires
    })
}

let getNewTokensDemo = function() {
    var params = {
        grant_type: "client_credentials",
        scope: "demo/test",
    }

    return API_aws_demo.post('/oauth2/token', qs.stringify(params), {
            headers: {
                'Authorization': 'Basic cjJ1aHU0OHE2ZW1ycnJybjloMTcxNGVuZjpyaXV1MHVydGdkcjVxYjByc2pwb2QyZGZsZmgzY2h1M3FmcjUwNHI5cTI4dmw2amE1MzI='
            }
        })
        .then(resp => {
            var idToken = resp.data.access_token
            storeToken(idToken, "id_token_demo", "60m")
        })
}

export default {
    getNewTokensDemo
}